import {baseGetRequest} from "../base/baseGetRequest";

const checkUserHasPin = async (login: string) =>
  baseGetRequest<number>(`/user_pin/user_has_pin/`, {login});

export default checkUserHasPin;
